import React from 'react'
import {Image, Mobile, Desktop} from '@miro-site/core'
import {Asset, Assets} from './types'

const DEVICE_BASED_COMPONENTS = {
  desktop: Desktop,
  mobile: Mobile,
}

function isMultipleAssets(assets: Assets | Asset): assets is Assets {
  return (assets as Assets).desktop !== undefined || (assets as Assets).mobile !== undefined
}

const LazyImageAdapter: React.FC<{assets: Assets | Asset; observer?: boolean}> = ({
  assets,
  observer = true,
}) => {
  if (isMultipleAssets(assets)) {
    return (
      <>
        {Object.entries(assets).map(([key, asset]) => {
          if (!asset.src) {
            return null
          }
          const WrapperComponent = DEVICE_BASED_COMPONENTS[key]
          return (
            <WrapperComponent key={key} $block={true}>
              <Image
                name={asset.alt}
                width={asset.width}
                height={asset.height}
                src={asset.src}
                detectIntersection={observer}
              />
            </WrapperComponent>
          )
        })}
      </>
    )
  }

  if (!assets.src) {
    return null
  }

  return (
    <Image
      name={assets.alt}
      width={assets.width}
      height={assets.height}
      src={assets.src}
      detectIntersection={observer}
    />
  )
}

export default LazyImageAdapter
